export default __webpack_public_path__ + "static/media/SD-parojshaseva-banner-bg.a7fb9d55.png";